import L from 'leaflet';

export const highlightLocationIcon = L.icon({
  iconUrl: require('../assets/venue_location_icon_red.svg'),
  iconRetinaUrl: require('../assets/venue_location_icon_red.svg'),
  iconAnchor: null,
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  iconSize: [30, 30],
  className: 'leaflet-venue-icon'
});
